// extracted by mini-css-extract-plugin
module.exports = {"container":"Tabs_container__3Qzqt","wrapper":"Tabs_wrapper__2Fsbi","names":"Tabs_names__3XgSL","name":"Tabs_name__Rv1i6","active":"Tabs_active__3jnT1"};